export default __webpack_public_path__ + "static/media/trash.32f674f4.svg";